import { render, staticRenderFns } from "./apps-roots.vue?vue&type=template&id=087b0d0c"
import script from "./apps-roots.vue?vue&type=script&lang=js"
export * from "./apps-roots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports